import { GET_ALL_SOURCE_TYPE } from '../../types'

const INITIAL_STATE = {
  getAllSourceType: [],
}

const sourceTypeReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case GET_ALL_SOURCE_TYPE:
      return {
        ...state,
        getAllSourceType: payload.data,
        loader: false,
      }

    default:
      return state
  }
}

export default sourceTypeReducer
